import { useEffect } from "react";
import SimpleButton from "../../components/disposables/buttons/SimpleButton";
import { CalibrationComponentType } from "../../navigation/CalibrationNavigator";
import {
  getCalibrationImage,
  getCalibrationStrings,
  Steps,
} from "../../utils/helpers/calibration-screen";
import styles from "./styles.module.css";
import { VisitedScreenEnum } from "@robotical/appv2-analytics-gatherer/dist/types/types";
import { t } from "i18next";

interface CalibrationScreenProps extends CalibrationComponentType { }

export default function CalibrationScreen({
  currentScreenSetter,
}: CalibrationScreenProps) {

  useEffect(() => {
    let stopHeartbeat: (() => void) | null = null;
    const logVisit = async () => {
      stopHeartbeat = await window.applicationManager.AnalyticsFacade.logScreenVisit(VisitedScreenEnum.CALIBRATION);
    };
    logVisit();

    return () => {
      if (stopHeartbeat) {
        stopHeartbeat();
      }
    };
  }, []);

  return (
    <div className={styles["calibration-screen-container"]}>
      <div className={styles["calibration-screen-marty-image-container"]}>
        <img src={getCalibrationImage(Steps.STEP01)} alt="marty-image" />
      </div>
      <div className={styles["calibration-screen-middle-text-container"]}>
        <p className={styles["calibration-screen-middle-text-title"]}>
          {getCalibrationStrings(Steps.STEP01).title}
        </p>
        <p className={styles["calibration-screen-middle-text-subtitle"]}>
          {getCalibrationStrings(Steps.STEP01).hint}
        </p>
      </div>
      <div className={styles["calibration-screen-bottom-buttons-container"]}>
        <SimpleButton
          title={t("calibration_screen.eye_calibration")}
          onClick={() => currentScreenSetter("eye-calibration")}
        />
        <SimpleButton
          title={t("calibration_screen.arm_calibration")}
          onClick={() => currentScreenSetter("arm-calibration")}
        />
        <SimpleButton
          title={t("calibration_screen.leg_calibration")}
          onClick={() => currentScreenSetter("leg-calibration-1")}
        />
        <SimpleButton
          title={t("calibration_screen.color_sensor_calibration")}
          onClick={() => currentScreenSetter("colour-sensor-calibration")}
        />
      </div>
    </div>
  );
}
